export default __webpack_public_path__ + "static/media/bus.6ec44282.png";